// Include external vendors
import $ from 'jquery';
const Foundation = require('foundation-sites');


function initAccordions() {

	const options = {
		multiExpand: true,
		allowAllClosed: true
	};
	const elem = new Foundation.Accordion($('.js--accordion'), options);
}

function initAccordionsMenu() {

	const options = {
		submenuToggle: true
	};
	const elem = new Foundation.AccordionMenu($('.js--accordion-menu'), options);
}

// init this script
export { initAccordions, initAccordionsMenu };
